/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Budget = {
    properties: {
        id: {
    type: 'number',
},
        ppd: {
    type: 'number',
    isRequired: true,
},
        glCode: {
    type: 'string',
    isRequired: true,
},
        budget: {
    type: 'number',
    isRequired: true,
    format: 'float',
},
        balance: {
    type: 'number',
    format: 'float',
},
        catId: {
    type: 'number',
    isRequired: true,
},
        createdAt: {
    type: 'string',
    format: 'date-time',
},
    },
};